var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFodlGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1140,
    height: 560,
    viewBox: "0 0 1140 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_803_2974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1142,
    height: 650
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1142,
    height: 650,
    fill: "#8148EC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_803_2974)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 1142,
    height: 650,
    fill: "#8148EC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_803_2974)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1099.87,
    cy: 525.431,
    rx: 518.505,
    ry: 318.394,
    fill: "#FFA84A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_803_2974)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.151,
    cy: 14.058,
    rx: 449.694,
    ry: 278.271,
    fill: "#E75E65"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_803_2974)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -285.8,
    cy: 741.697,
    rx: 449.694,
    ry: 278.271,
    fill: "#262345"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_803_2974",
    x: 43.7408,
    y: -330.588,
    width: 2112.26,
    height: 1712.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 268.813,
    result: "effect1_foregroundBlur_803_2974"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_803_2974",
    x: -432.168,
    y: -801.838,
    width: 1974.64,
    height: 1631.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 268.813,
    result: "effect1_foregroundBlur_803_2974"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_803_2974",
    x: -1273.12,
    y: -74.1995,
    width: 1974.64,
    height: 1631.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 268.813,
    result: "effect1_foregroundBlur_803_2974"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFodlGradient);
export default __webpack_public_path__ + "static/media/fodl_gradient.af20ca6c78e1da5baaab421a4cf15194.svg";
export { ForwardRef as ReactComponent };